<template>
    <div class="white pa-4">
        <Block v-if="loading" />

        <v-row class="mt-2">
            <v-col cols="12" md="6">
                <v-autocomplete v-model="id_seller" outlined dense attach label="Vendedor" :items="ExpiredAccountsSellerList" item-text="name"
                    item-value="value" @change="getData()"></v-autocomplete>
            </v-col>
            <!-- Ocultado temporalmente
            <v-col cols="12" md="6" class="d-flex justify-end">
                <v-btn class="btn-save" @click="setupPrint">
                    <v-icon>mdi-printer</v-icon>
                </v-btn>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="search.envType">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <VersatileFilter :columnsSearch="columsConfig" :search="search" @emptyFilter="getData" advancedFilter
            @filtered="filterHandler" :key="Reloadfilter" disableDates :columnfilterEndpoint="getData">
            <DxDataGrid :dataSource="DataTable" :columns="columnsList" @exporting="onExporting"
                :word-wrap-enabled="true" :scrolling="{ useNative: true }" :column-auto-width="true">
                <DxExport :enabled="true" />
                <template #show-template-class="{ data }">
                    <div>{{ showClass(data.data.id_class) }}</div>
                </template>
                <template #show-template-category="{ data }">
                    <div>{{ showCategories(data.data.id_category) }}</div>
                </template>
                <template #show-template-subcategory="{ data }">
                    <div>{{ showSubs(data.data.id_subcategory) }}</div>
                </template>
                <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
                <DxPaging :page-size="10" />
            </DxDataGrid>
        </VersatileFilter>

        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert" />
        <div>
            <component v-for="(item, index) in PrintList" :key="index" :is="item.component" v-bind="item.props" />
        </div>
    </div>
</template>

<script>

//import {mapState} from 'vuex';
import VersatileFilter from '@/components/VersatileFilter.vue';
import { DxDataGrid, DxPager, DxPaging, DxExport } from 'devextreme-vue/data-grid';
import Block from '@/components/Block.vue';
import Alerts from '@/components/Alerts.vue';
import { printToExcel } from "@/helpers/printToexcel";
import PrintAccountsReceivableStatement from "@/components/ReportsAndPrintings/SalesReports/PrintAccountsReceivableStatement"

export default {
    name: "CustomersAccounts",
    components: {
        DxDataGrid,
        DxPager,
        DxPaging,
        Block,
        Alerts,
        DxExport,
        VersatileFilter,
        PrintAccountsReceivableStatement
    },
    props: ['win'],
    data() {
        const additionalInformationTitle = Number(JSON.parse(localStorage.getItem("user") || "{}").IsOptical) === 1
            ? "Lugar de trabajo"
            : "Información adicional";
        return {
            additionalInformationTitle,
            PrintList: [],
            print: {
                show: false,
                header: {
                },
                data: [],
            },
            Customers: [],
            DataTable: [],
            panel: 0,
            tab: null,
            key: 0,
            loading: false,
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            ClientList: [],
            ExpiredAccountsSellerList: [],
            requestDate: null,
            customer: null,
            columnsList: [
                { dataField: "ID_Customer", caption: "Cód. Cliente" },
                // { dataField: "ID_Invoice", caption: "No. Documento" },
                { dataField: "LegalName" , caption: "Cliente" },
                { dataField: "AdditionalInformation", caption: additionalInformationTitle },
                { cellTemplate:"show-template-class" , caption: "Clase" },
                { cellTemplate:"show-template-category" , caption: "Categoría" },
                { cellTemplate:"show-template-subcategory" , caption: "Subcategoría" },
                { dataField: "Phone" , caption: "Telefono" },
                { dataField: "Cellphone" , caption: "Celular" },
                // { dataField: "FullNameCustomer" , caption: "Nombre Legal" },
                { dataField: "City", caption: "Municipio" },
                { dataField: "State", caption: "Departamento" },
                { dataField: "ID_Seller", caption: "Cód. Vendedor" },
                { dataField: "sellerName", caption: "Vendedor" },
                { dataField: "plazo", caption: "Plazo" },
                { dataField: "LimitCredit", caption: "Limite" },
                { dataField: "Saldo", caption: "Saldo" },
                { dataField: "Disponible", caption: "Disponible" },
            ],
            columsConfig: [
                { name: "ID_Customer", title: "Cód. Cliente", value: "", type: "text" },
                { name: "LegalName", title: "Nombre de Cliente", value: "", type: "text" },
                { name: "ID_Seller", title: "Cód. Vendedor", value: "", type: "text" },
                { name: "sellerName", title: "Nombre de Vendedor", value: "", type: "text" },
                {
                    name: "id_class",
                    title: "Clase",
                    value: "",
                    type: "select",
                    options: [],
                    onChange: this.getCategoriesByClass,
                },
                {
                    name: "id_category",
                    title: "Categoría",
                    value: "",
                    type: "select",
                    options: [],
                    onChange: this.getSubsByCategory,
                    disabled: true,
                },
                {
                    name: "id_subcategory",
                    title: "Subategoría",
                    value: "",
                    type: "select",
                    options: [],
                    disabled: true,
                },
                { name: "AdditionalInformation", title: additionalInformationTitle, value: "", type: "text" },
            ],
            Currency: JSON.parse(localStorage.getItem('branch')).Currency || "",
            idbusiness: JSON.parse(localStorage.getItem("user")).businessid || "",
            idbranch: JSON.parse(localStorage.getItem("user")).branch || "",
            search: {
                ID_Seller: null,
                envType: '01',
            },
            dates: {},
            useDate : false,
            Reloadfilter: 0,
            businessAndBranchInfo: []
        }
    },
    watch: {
        envType() {
            this.getData();
        }
    },  
    computed: {

    },
    async mounted() {
        const date = new Date()
        this.requestDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate()}`;
        await this.loadSellers();
        // await this.getCustomersAccountStatus()
        if (this.Customers.length > 0) {
            await this.loadData();
        }
        this.getClasses();
        this.getCategories();
        this.getSubs();
    },
    methods: {
        async loadData() {
            await this.getData();
        },
        async loadSellers(){
            try {
                const { data: response } = await this.$API.customers.getExpiredAccountsReceivableSellers( this.requestDate, this.daysOfDue );
                this.ExpiredAccountsSellerList.push({name: "Sin vendedor asignado", value: 'noSeller'});
                this.ExpiredAccountsSellerList.push({ name: "Ver todos los clientes", value: 'ALL' });
                this.ExpiredAccountsSellerList.push(...response);
                this.id_seller = this.ExpiredAccountsSellerList[0].value;
            } catch (error) {
                this.showAlert( 'error', 'Error', 'No fue posible cargar los datos del vendedor' );
            }
        },
        onExporting(e) {
            if(this.id_seller == '') {
                return;
            }
            const customerdata = this.id_seller == 'ALL' ? this.ExpiredAccountsSellerList : this.ExpiredAccountsSellerList.find(seller => seller.value === this.id_seller);
            printToExcel(e, `Reporte de cobros${this.id_seller == 'ALL' ? `` : ` ${customerdata.name}`}`);
        },
        filterHandler(data) {
            console.log('data', data);
            if (data.length > 0) {
                this.DataTable = data.map(item => {
                    return item
                });
                return;
            }
            this.DataTable = [];

        },
        setupPrint() {
            if(this.customer === this.ClientList[0].value) {
                return;
            }
            this.print.data.body = this.DataTable;
            this.print.header.title = "Reporte de Cuentas por Cobrar por Vendedor ";
            const customer = this.ClientList.find(customer => customer.value === this.customer);
            
            if (customer.value == 'ALL') {
                this.print.header.subtitle = "Sin vendedor asignado";
            }
            else {
                this.print.header.subtitle = "ID : " + customer.value + " - " + customer.name;
            }
            this.print.show = true;
            this.PrintList.push({
                component: PrintAccountsReceivableStatement, props: {
                    dataProps: this.print,
                    dataCustomer: customer,
                    bussinessInfo: this.businessAndBranchInfo
                }
            });
        },
        async getData(find) {
            // console.log(`getData`, find);
            try {
                this.loading = true;

                this.search.ID_Seller = this.id_seller;
                
                // console.log('this.search', this.search);

                let response = await this.$API.customers.getCustomerBySeller({
                    extraParam1: this.extraParam1, 
                    filter : find?.filter ?? JSON.stringify([]),
                    business: this.search.business,
                    branch: this.search.branch,
                    search: JSON.stringify(this.search),
                    like: find?.like,
                    selectedItem: this.radioSelect != [] ? this.selectedItem : null,
                    dates: this.useDate ? JSON.stringify( {
                        ...this.dates
                    }) : JSON.stringify({}),
                    hideNoStockRecords: this.oNoStockRecords,
                    envType: this.search.envType,
                });
                if (response.length > 0) {
                    this.DataTable = response
                    // this.formatTable()
                }
                else {
                    this.DataTable = [];
                }

                const response2 = await this.$API.branches.findSpecificBranch(
                    { "branch": this.idbranch, "business": this.idbusiness })
                this.businessAndBranchInfo = response2
            } catch (error) {
                console.error(error)
                this.showAlert('danger', 'Error', error.response.data.message);
            } finally {
                this.loading = false;
            }
        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.alert.show = false;
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        getClasses() {
            this.$API.customersTypes.getClasses().then((response) => {
                this.columsConfig[4].options = response.map(element => ({name: element.name, value: element.id}));
            });
        },
        getCategories() {
            this.$API.customersTypes.getCategories().then((response) => {
                this.columsConfig[5].options = response.map(element => ({name: element.name, value: element.id}));
                this.categoriesAll = response;
            });
        },
        getSubs() {
            this.$API.customersTypes.getSubs().then((response) => {
                this.columsConfig[6].options = response.map(element => ({name: element.name, value: element.id}));
                this.subcategoriesAll = response;
            });
        },
        getCategoriesByClass() {
            delete this.columsConfig[5].value;
            delete this.columsConfig[6].value;
            this.columsConfig[5].options = this.categoriesAll.filter(element => element.id_class === this.columsConfig[4].value).map(element => ({name: element.name, value: element.id}));
            this.columsConfig[5].disabled = false;
            this.columsConfig[6].disabled = true;
        },
        getSubsByCategory() {
            delete this.columsConfig[6].value;
            this.columsConfig[6].options = this.subcategoriesAll.filter(element => element.id_cat === this.columsConfig[5].value).map(element => ({name: element.name, value: element.id}));
            this.columsConfig[6].disabled = false;
        },
        showClass(idClass) {
            const classData = this.columsConfig[4].options.find(element => element.value === idClass);
            return classData?.name ?? '';
        },
        showCategories(idCategory) {
            const categoryData = this.categoriesAll.find(element => element.id === idCategory);
            return categoryData?.name ?? '';
        },
        showSubs(idSubcategory) {
            const subcategoryData = this.subcategoriesAll.find(element => element.id === idSubcategory);
            return subcategoryData?.name ?? '';
        },
    },

}
</script>

<style scoped>
.bar {
    width: 100%;
    background-color: rgb(60, 60, 60) !important;
    color: white !important;
    border-style: solid;
    border-color: black;
    border-radius: 15px !important;
    margin-top: 1rem !important;
}

.btn-add {
    background-color: #3498DB !important;
    color: white;
}

.btnsave {
    background-color: #00A178 !important;
    color: white;
}

.btnclean {
    background-color: #F29D35 !important;
    color: white;
}

.btndelete {
    background-color: #E3191E !important;
    color: white;
}
</style>
